// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';
import classNames from 'classnames/bind';
import { withFocus } from '@accedo/vdkweb-navigation';
import { SearchIcon, UserIcon, SettingsIcon } from '#/components/Icons/Icons';
import Avatar from '#/components/Avatar';
import johnImage from '#/static/images/user.jpg';
import snowflake from '#/static/images/snowflake.svg';
import style from './menuItem.scss';

interface MenuItemProps {
  onClick: any;
  colorIndex?: string;
  data: any;
  nav: any;
  userFullname?: string;
}

const icons = {
  search: () => <SearchIcon />,
  profile: () => <UserIcon />,
  settings: () => <SettingsIcon />
};

const SnowflakeIcon = () => (
  <svg
    width="40"
    height="46"
    viewBox="0 0 40 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.9002 32.875C39.1534 32.9992 39.3432 33.2207 39.4257 33.4881C39.5081 33.7573 39.4755 34.0457 39.3355 34.2901C39.1955 34.5327 38.9597 34.7064 38.6855 34.7714C38.4113 34.8344 38.1236 34.7809 37.8897 34.6262L35.0574 32.9934L35.577 34.949C35.7228 35.4876 35.4006 36.0433 34.8579 36.1884C34.3152 36.3317 33.7591 36.0108 33.6134 35.4723L32.5683 31.5612L29.6228 29.8845L30.8309 34.378V34.3761C30.9747 34.9166 30.6526 35.4704 30.1099 35.6155C29.5691 35.7607 29.0111 35.4398 28.8673 34.8994L27.1683 28.4617L23.6284 26.4221L20.6829 28.1046V32.1628L25.4194 36.8855V36.8836C25.8164 37.2789 25.8164 37.9168 25.4194 38.3121C25.0244 38.7055 24.382 38.7055 23.987 38.3121L20.7174 35.0274V38.3866L23.5746 41.232V41.2301C23.9026 41.6312 23.8738 42.2117 23.5094 42.5803C23.1451 42.947 22.5621 42.9833 22.1556 42.6624L20.7328 41.2397V44.511C20.7328 45.0705 20.2764 45.5232 19.7164 45.5232C19.1546 45.5232 18.7001 45.0705 18.7001 44.511V41.2397L17.2466 42.6624C16.8458 43.031 16.2245 43.0176 15.839 42.6319C15.4536 42.248 15.4421 41.6292 15.8122 41.2301L18.6694 38.3846V35.0273L15.3807 38.3159C14.9857 38.7112 14.3433 38.7112 13.9483 38.3159C13.5513 37.9225 13.5513 37.2827 13.9483 36.8893L18.6848 32.1666V28.1084L15.7738 26.4221L12.2435 28.456L10.5023 34.9049C10.3565 35.4435 9.79851 35.7643 9.25772 35.621C8.71502 35.4759 8.39289 34.9202 8.53864 34.3816L9.74672 29.888L6.8262 31.5648L5.78111 35.4759H5.77919C5.63345 36.0164 5.07734 36.3372 4.53464 36.192C3.99194 36.0488 3.6698 35.4931 3.81555 34.9526L4.33523 32.997L1.53744 34.626C1.05804 34.859 0.476978 34.6814 0.210464 34.2212C-0.0560851 33.759 0.0819833 33.1708 0.52687 32.8748L3.35534 31.2477L1.3917 30.7245H1.38979C1.12899 30.6538 0.908465 30.4858 0.772321 30.2528C0.638087 30.0198 0.601652 29.7448 0.670688 29.4851C0.816429 28.9446 1.37254 28.6238 1.91524 28.7689L5.84251 29.8097L8.7592 28.133L4.24706 26.9299C3.98626 26.8611 3.76574 26.6912 3.62959 26.4582C3.49536 26.2271 3.45892 25.9502 3.52796 25.6905C3.6737 25.1519 4.22981 24.8311 4.77251 24.9744L11.2481 26.7046L14.7784 24.6765L14.7765 21.3173L11.2462 19.2892L4.74752 21.0442C4.20482 21.1893 3.64872 20.8685 3.50297 20.3281C3.35915 19.7876 3.68131 19.2338 4.22205 19.0886L8.73803 17.8855L5.79257 16.2088L1.8653 17.2496H1.86722C1.32452 17.3947 0.766499 17.0739 0.622663 16.5335C0.476922 15.9949 0.799086 15.4392 1.34175 15.294L3.30538 14.7708L0.50185 13.1246C0.0166942 12.84 -0.144383 12.2174 0.141336 11.7324C0.42706 11.2492 1.05222 11.0888 1.53738 11.3733L4.36968 13.0061L3.85001 11.0506C3.70427 10.512 4.02643 9.9563 4.56909 9.81115C5.11179 9.66792 5.66789 9.98875 5.81364 10.5273L6.85874 14.4384L9.77926 16.1151L8.57118 11.6216V11.6235C8.42736 11.083 8.74952 10.5292 9.29222 10.384C9.83301 10.2389 10.391 10.5597 10.5348 11.1002L12.2683 17.5437L15.7737 19.5776L18.7192 17.8951V13.837L13.9827 9.11419V9.1161C13.5857 8.72079 13.5857 8.08293 13.9827 7.68762C14.3777 7.29421 15.0201 7.29421 15.4151 7.68762L18.7192 10.9781V7.61506L15.862 4.76958C15.5801 4.37236 15.6203 3.83189 15.9598 3.48244C16.2973 3.13296 16.838 3.07185 17.2465 3.3373L18.6693 4.76006V1.48871C18.6693 0.929176 19.1257 0.476562 19.6857 0.476562C20.2475 0.476562 20.702 0.929166 20.702 1.48871V4.74481L22.1555 3.33734C22.5563 2.96877 23.1776 2.98214 23.5631 3.3679C23.9485 3.75176 23.96 4.37051 23.5899 4.76964L20.7327 7.61512V10.9724L24.0367 7.68195L24.0348 7.68386C24.4318 7.28855 25.0742 7.28855 25.4692 7.68386C25.8642 8.07727 25.8642 8.71703 25.4692 9.11044L20.7327 13.8332V17.8914L23.6283 19.5777L27.1586 17.5438L28.8921 11.1002H28.8902C28.9611 10.8405 29.1299 10.619 29.3638 10.4853C29.5978 10.3516 29.874 10.3153 30.1347 10.3841C30.6774 10.5292 30.9996 11.083 30.8538 11.6235L29.6457 16.1171L32.5912 14.4403L33.6363 10.5292L33.6382 10.5273C33.7072 10.2695 33.8779 10.048 34.1118 9.9143C34.3439 9.77871 34.6219 9.74243 34.8827 9.81118C35.4254 9.95631 35.7456 10.512 35.6018 11.0506L35.0821 13.0062L37.9144 11.3734C38.3938 11.1404 38.9729 11.318 39.2395 11.7782C39.506 12.2404 39.368 12.8286 38.925 13.1246L36.0965 14.7517L38.0602 15.2749C38.6029 15.4201 38.925 15.9739 38.7793 16.5143C38.6354 17.0548 38.0774 17.3756 37.5347 17.2305L33.6074 16.1897L30.6907 17.8664L35.1799 19.0886C35.7206 19.2338 36.0428 19.7876 35.8989 20.3281C35.7532 20.8685 35.1971 21.1893 34.6544 21.0442L28.1788 19.2892L24.6485 21.3173V24.6803L28.1788 26.7084L34.6544 24.9782V24.9801C35.1971 24.835 35.7532 25.1558 35.8989 25.6962C36.0428 26.2367 35.7206 26.7905 35.1799 26.9356L30.6639 28.1388L33.6093 29.8155L37.5366 28.7747L37.5347 28.7728C38.0774 28.6296 38.6354 28.9504 38.7793 29.4889C38.925 30.0294 38.6028 30.5851 38.0602 30.7283L36.0965 31.2516L38.925 32.8787L38.9002 32.875ZM22.3915 24.5639V21.4549L19.701 19.9061L17.0106 21.4568V24.5467L19.701 26.0936L22.3915 24.5639Z"
      fill="white"
    />
  </svg>
);

/**
 * MenuItem Component
 * @param {Object} props Component Props
 * @param {Function} props.onClick Callback function to dispatch when
 * @param {Object} props.data The content to be displayed
 * @param {Object} props.userFullname userFullname to be used in the avatar
 * @returns {React.ReactComponentElement} Component
 */
const MenuItem = ({
  onClick,
  colorIndex,
  data,
  nav,
  userFullname
}: MenuItemProps) => {
  const [content, setContent] = useState<any>(null);
  const [contentStyle, setContentStyle] = useState<string>('');

  const { pathname } = useLocation();

  const { itemGroup, viaIconLabel, image, displayText } = data;

  const isIcon = useCallback(() => !!viaIconLabel, [viaIconLabel]);

  const isProfile = useCallback(() => displayText === 'Profile', [displayText]);

  const isSelected = useCallback(() => pathname === data.route, [
    pathname,
    data.route
  ]);

  const isOlympics = data.displayText.toLowerCase().includes('olympics');

  const getIcon = (iconType: 'search' | 'profile' | 'settings') =>
    icons[iconType];
  const cx = classNames.bind(style);

  useEffect(() => {
    if (isProfile()) {
      setContent(
        <Avatar
          src={image || johnImage}
          name={userFullname}
          isFocused={nav.isFocused}
        />
      );
      setContentStyle(style.avatar);
      return;
    }

    if (isIcon() && getIcon(viaIconLabel)) {
      setContent(getIcon(viaIconLabel));
      setContentStyle(style.icon);
      return;
    }

    setContent(data.displayText);

    if (isOlympics) {
      setContentStyle(style.olympics);
      return;
    }

    setContentStyle(style.default);
  }, [nav.isFocused, viaIconLabel, data.displayText, image]);

  return (
    <div
      className={`${style.item} ${style[itemGroup]} ${
        nav.isFocused ? style.focused : ''
      } ${isSelected() ? style.selected : ''}`}
      onMouseOver={nav.onMouseOver}
      onMouseOut={nav.onMouseOut}
    >
      <div
        className={classnames(
          contentStyle,
          isOlympics ? '' : cx(`color_${colorIndex}`)
        )}
      >
        {isOlympics && <SnowflakeIcon />}
        <button onClick={onClick}>{content}</button>
        {isOlympics && <SnowflakeIcon />}
      </div>
    </div>
  );
};

export default withFocus(MenuItem);
